import Extras from './booking-components/extras'
import { updateBookingStepper } from './booking-stepper'

class ExtrasDemoManager {
    constructor() {
        this.demoPage = document.querySelector('#holiday-park-extras-demo-page')
        this.extrasPage = this.demoPage?.querySelector('#extras-page')
        this.bookingSummary = this.demoPage?.querySelector('#booking-summary')
        this.bookingStepper = this.demoPage?.querySelector('#booking-stepper')
        this.bookingNo = this.demoPage?.dataset?.booking_id ?? null
    }

    async init() {
        if (!this.demoPage || !this.extrasPage || !this.bookingNo) {
            return
        }

        updateBookingStepper(this.bookingStepper, 1)

        const extras = new Extras(this.extrasPage, this.bookingNo, this.bookingSummary)
        await extras.onLoad(2)
    }
}

function isExtrasDemoPage() {
    return document.querySelector('#holiday-park-extras-demo-page')
}

window.addEventListener("DOMContentLoaded", async () => {
    if (isExtrasDemoPage()) {
        const extrasDemoManager = new ExtrasDemoManager()
        await extrasDemoManager.init()
    }
})
